const formatter = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
})
const currencyFormatter = (amount) => formatter.format(amount)
export default currencyFormatter
